import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addHighestEducation } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ055 } from "../../lib/google-analytics";
import { googleEvent_LOJ053 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function HighestEducation() {
  const [loading, setLoading] = useState(false);

  const { highestEducation } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();
  const navigate = useNavigate();

  const data = [
    "Below 10th",
    "Secondary School (10th)",
    "Senior Secondary School (12th)",
    "Diploma",
    "Bachelors",
    "Masters",
  ];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addHighestEducation(data.value));

      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ053();
  }, []);

  useEffect(() => {
    loading ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Personal Info"
          showProgress={true}
          percent={23.07}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />

        <div className="mb-3">
          <p className="label">Highest Education</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "education",
                value: item,
              });

              // Events
              googleEvent_LOJ055(item, item);
            }}
          >
            <SelectOption name={item} checked={highestEducation} />
          </div>
        ))}
      </div>
    </>
  );
}
